// =====================================================
// BDSJEA-502: criterio único de «siembras vigentes» (Actividad Agrícola,
// Informe Agropecuario y Proyección Crediticia). Texto compartido por los
// paneles «¿Cómo se calcula?».
// =====================================================
import React from "react"

export const TEXTO_SIEMBRAS_VIGENTES =
  "Se consideran vigentes: (a) las siembras importadas del sistema anterior que pertenecen al último plan productivo del productor, sin importar la campaña activa ni si figuran cosechadas; (b) las siembras cargadas en Ewan que están en la campaña activa y no están cosechadas ni perdidas."

const SiembrasVigentesNota = () => (
  <p
    className="mb-3 p-2 border rounded bg-light"
    style={{ fontSize: "0.82rem" }}
    data-testid="nota-siembras-vigentes"
  >
    <strong>Siembras que entran en el cálculo.</strong>{" "}
    {TEXTO_SIEMBRAS_VIGENTES}
  </p>
)

export default SiembrasVigentesNota
